import { render, staticRenderFns } from "./InputTextBox.vue?vue&type=template&id=1846e464&"
import script from "./InputTextBox.vue?vue&type=script&lang=ts&"
export * from "./InputTextBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports